// import { Paper } from '@mui/material'
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
// import { ReactComponent as HeartIcon } from '../../assets/images/edit.svg'
import BarChart from '../BarChart';
import moment from 'moment';
import PropTypes from 'prop-types';
import { find } from 'lodash';

function Graphs({ measure, measuresData }) {
  const [currentShow] = useState(find(showOptions, { key: measure }) || {});
  const [xGraphData, setXGrapghData] = useState([]);
  const [yGraphData, setYGrapghData] = useState([]);

  // const changeShowHandler = (newShow) => {
  //     setCurrentShow(newShow)
  // }

  const makinDataForGraph = (data, paramForX, ParamForY) => {
    const newXData = data.map((obj) => obj[paramForX]);
    const newYData = data.map((obj) => moment(obj[ParamForY]).format('MM.YY'));
    setXGrapghData(newXData);
    setYGrapghData(newYData);
  };

  useEffect(() => {
    if (Object.keys(currentShow).length && measuresData?.length)
      makinDataForGraph(measuresData, currentShow.xParam, currentShow.yParam);
  }, [currentShow, measuresData]);

  return (
    <div className={styles.graphs}>
      <div className={styles.graphTitle}>{currentShow.label}</div>
      <div className={styles.graphsBox}>
        <BarChart xGraphData={xGraphData} yGraphData={yGraphData} />
      </div>
    </div>
  );
}

export default Graphs;

Graphs.propTypes = {
  measuresData: PropTypes.array,
  measure: PropTypes.string
};

const showOptions = [
  {
    key: 'weight',
    label: 'גרף משקל',
    xParam: 'whight',
    yParam: 'lastUpdated'
  },
  {
    key: 'heart',
    label: 'פעילות לב',
    xParam: 'heartBeatRate',
    yParam: 'lastUpdated'
  },
  {
    key: 'muscle',
    label: 'שריר וגמישות',
    xParam: 'muscleStrength',
    yParam: 'lastUpdated'
  },
  {
    key: 'fatPct',
    label: 'אחוזי שומן',
    xParam: 'fatPct',
    yParam: 'lastUpdated'
  },
  {
    key: 'bloodPressureDys',
    label: 'לחץ דם',
    xParam: 'bloodPressureDys',
    yParam: 'lastUpdated'
  },
  {
    key: 'MuscleMass',
    label: 'מסת שריר',
    xParam: 'MuscleMass',
    yParam: 'lastUpdated'
  },
  {
    key: 'muscleStrength',
    label: 'כח שריר',
    xParam: 'muscleStrength',
    yParam: 'lastUpdated'
  },
  {
    key: 'flexibilityIndex',
    label: 'גמישות',
    xParam: 'flexibilityIndex',
    yParam: 'lastUpdated'
  }
];
